import { render } from "./TheProfessionalDocumentList.vue?vue&type=template&id=97c69a8e&ts=true"
import script from "./TheProfessionalDocumentList.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalDocumentList.vue?vue&type=script&lang=ts"

import "./TheProfessionalDocumentList.vue?vue&type=style&index=0&id=97c69a8e&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__